import { ProductionOutputParameters, ProductionOutputPreset, ProductionOutputType } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getAll() {
  return DesignService.get<readonly ProductionOutputPreset[]>('productionOutputPresets');
}

export function insert(
  name: string,
  outputTypes: readonly ProductionOutputType[],
  parameters: ProductionOutputParameters,
) {
  return DesignService.post<ProductionOutputPreset>('productionOutputPresets', {
    data: { name, outputTypes, parameters },
  });
}

export function remove(guid: string) {
  return DesignService.delete<void>(`productionOutputPresets/${guid}`);
}
